<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
            :ref="'landmark_typesCrud'"
            :crudName="$t('Landmark Types')"
            :newText="$t('Add')+ '  '+$t('New')"
            :table="table" :columns="columns"
            :options="options"
            :endPoint="endPoint"
            :enableAdd="true"
            :enableEdit="true"
            :enableDelete="true"
            :enableView="false"
            :enableReset="false"
            :dataForm="dataForm">
        </base-crud>

      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import ViewImage from "../../layouts/components/ViewImage";

export default {
  data: function () {
    return {
      table: "landmark_typesTable",
      showMessageImport: false,
      landmark_typesCrud: {},
      pages: [],
      url: "",
      columns: [
        "id",
        "name",
        "image",
        "actions",
      ],
      optionsOrigin: {
        filterByColumn: true,
        debounce: 1000,
        filterable: ["id", "name", "sigla"],
        pagination: {
          chunk: 10,
          dropdown: false,
          nav: "scroll"
        },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: this.$t('id'),
          name: this.$t('Name'),
          image: this.$t('image'),
          actions: this.$t('action'),
        },
        texts: {
          filterBy: this.$t('Filter'),
          defaultOption: this.$t('Select'),
        },
        templates: {
          image: function (h, row, index) {
            return row.upload_files ? h('b-avatar', {props: {src: row.upload_files.url, size: '2rem'}}) : '';
          },

        },
        requestFunction: function (data) {
          const requestData = {};
          const query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = ["uploadFiles"];


          return axios.get(this.url + "?" + query, requestData).catch(
              function (e) {
                this.dispatch("error", e);
              }.bind(this)
          );
        },
      },
      tableData: ["id", "name", "image"],
      endPoint: "landmark_types",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
    ViewImage,
  },
  computed: {
    options() {
      const headings = {
        id: this.$t('id'),
        name: this.$t('Name'),
        image: this.$t('image'),
        actions: this.$t('action'),
      }

      const texts = {
        filterBy: this.$t('Filter'),
        defaultOption: this.$t('Select'),
      }
      return {
        ...this.optionsOrigin,
        texts,
        headings,
      }

    }

  },

  methods: {
    makeFormData: function () {
      const self = this;
      let fd = new FormData();

      let fileImport = document.getElementById("fileImport");

      fd.append("fileImport", fileImport.files[0] ? fileImport.files[0] : "");

      return fd;
    },
    query: function (query) {
      let columns = {
        id: "id",
        name: "name",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
    openInput() {
      document.getElementById("fileImport").click();
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}

.uploading-image {
  display: flex;
  border-radius: 10px;
  width: 100px;
  height: 100px;
}
</style>
